import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Sparkles } from "lucide-react";
import { Reveal } from "@/components/marketing/kit";
import { ARTICLES } from "@/components/marketing/content";

export default function ArticleDetail() {
  const { slug } = useParams();
  const a = ARTICLES.find((x) => x.slug === slug);
  const more = ARTICLES.filter((x) => x.slug !== slug).slice(0, 3);
  if (!a) return (
    <main><section className="mk-sec"><div className="mk-wrap mk-head">
      <h1 className="mk-h2">Article not found</h1>
      <Link to="/resources" className="mk-btn ghost" style={{ margin: "20px auto 0", width: "max-content" }}>Back to resources</Link>
    </div></section></main>
  );
  return (
    <main><section className="mk-sec"><div className="mk-wrap">
      <article className="mk-article">
        <Link to="/resources" className="back" data-testid="article-back"><ArrowLeft size={15} /> All resources</Link>
        <div className="mk-res-meta"><span className="cat">{a.category}</span><span className="read">{a.read} read</span></div>
        <h1 data-testid="article-title">{a.title}</h1>
        <Reveal className="mk-article-cover"><img src={`${a.cover}&w=1000`} alt={a.title} /></Reveal>
        <div className="mk-article-body" data-testid="article-body">
          {a.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>

        <div className="mk-case-quote" style={{ borderLeftColor: "var(--cyan)" }}>
          Want to put this into action? HypeFlow turns these ideas into a workflow.
          <span><Link to="/login?mode=register" style={{ color: "var(--cyan)" }} data-testid="article-cta">Start free →</Link></span>
        </div>
      </article>

      <div className="mk-res-grid" style={{ marginTop: 40 }}>
        {more.map((m) => (
          <Link key={m.slug} to={`/resources/${m.slug}`} className="mk-res-card" data-testid={`article-related-${m.slug}`}>
            <div className="mk-res-card-img"><img src={`${m.cover}&w=600`} alt={m.title} /></div>
            <div className="mk-res-card-body"><div className="mk-res-meta"><span className="cat">{m.category}</span></div><h3>{m.title}</h3></div>
          </Link>
        ))}
      </div>
    </div></section></main>
  );
}
